import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-517c908c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex message-wrapper" }
const _hoisted_2 = { class: "d-flex flex-column justify-content-between message-container" }
const _hoisted_3 = { class: "title-content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_8 = { class: "options-container" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FbxButton = _resolveComponent("FbxButton")!
  const _component_ReturnOptions = _resolveComponent("ReturnOptions")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overlay-background", { 'message-full-screen': _ctx.fullScreen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "before-title", {}, undefined, true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["fb-form-heading title", { bold: _ctx.boldTitle }]),
              innerHTML: _ctx.titleText
            }, null, 10, _hoisted_4),
            (_ctx.subheadingText)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "subheading-text",
                  innerHTML: _ctx.subheadingText
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.subtitleText)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["fb-form-heading", _ctx.subtitleStyle]),
                  innerHTML: _ctx.subtitleText
                }, null, 10, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trailerOptions, (trailer, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["trailer-option", _ctx.isSelected(i) ? 'selected' : '']),
                onClick: ($event: any) => (_ctx.selectOption(i)),
                key: i
              }, _toDisplayString(trailer.trailerNumber), 11, _hoisted_9))
            }), 128)),
            _createElementVNode("div", {
              class: _normalizeClass(["trailer-option", 
                                _ctx.isSelected(_ctx.UNKNOWN_TRAILER_SELECTION_INDEX)
                                    ? 'selected'
                                    : ''
                            ]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
                                _ctx.selectOption(_ctx.UNKNOWN_TRAILER_SELECTION_INDEX)
                            ))
            }, " I don't know ", 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["footer-text", _ctx.footerStyle]),
            innerHTML: _ctx.footerText
          }, null, 10, _hoisted_10)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["content", { 'buttons-padding': _ctx.includeReturnDeepLink }])
        }, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.goBackText !== '')
              ? (_openBlock(), _createBlock(_component_FbxButton, {
                  key: 0,
                  "button-text": _ctx.goBackText,
                  "show-loading": _ctx.goBackLoading,
                  theme: _ctx.goBackTheme,
                  disabled: _ctx.disabled,
                  onClick: _ctx.goBackClicked
                }, null, 8, ["button-text", "show-loading", "theme", "disabled", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.selectText !== '')
              ? (_openBlock(), _createBlock(_component_FbxButton, {
                  key: 1,
                  "button-text": _ctx.selectText,
                  "show-loading": _ctx.selectLoading,
                  theme: _ctx.selectTheme,
                  disabled: _ctx.selectDisabled,
                  onClick: _ctx.selectClicked
                }, null, 8, ["button-text", "show-loading", "theme", "disabled", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (_ctx.includeReturnDeepLink || _ctx.fullScreen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
                        'message-footer text-center',
                        { 'full-screen': _ctx.fullScreen },
                    ])
            }, [
              _createVNode(_component_ReturnOptions, { "in-modal": true })
            ], 2))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}